export enum DemandPartnerEnum {
  AOL = 'AOL',
  OPENX = 'OPENX',
  OPENX_HB = 'OPENX_HB',
  ADX = 'ADX',
  INDEX = 'INDEX',
  SONOBI = 'SONOBI',
  SOVRN = 'SOVRN',
  APP_NEXUS = 'APP_NEXUS',
  PUBMATIC = 'PUBMATIC',
  SERVERBID = 'SERVERBID',
  RUBICON = 'RUBICON',
  BREAL_TIME = 'BREAL_TIME',
}

export const DemandPartnerDbName = {
  ADX: 'Adx',
  AOL: 'AOL',
  OPENX_HB: 'OpenX_HB',
  INDEX: 'Index',
  SOVRN: 'Sovrn',
  SONOBI: 'Sonobi',
  EMX: 'EMX',
  SERVERBID: 'Serverbid',
  APP_NEXUS: 'AppNexus',
  PUBMATIC: 'PubMatic',
  RUBICON: 'Rubicon',
  BREAL_TIME: 'bRealTIme'
};


export const EbChannelDPs = [DemandPartnerDbName.SONOBI, DemandPartnerDbName.PUBMATIC];
